/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPlaceholder24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={25}
      height={25}
      fill='none'
      viewBox='0 0 25 25'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M2.442 9.356a6.914 6.914 0 1113.829 0 6.914 6.914 0 01-13.829 0zM9.356.942a8.414 8.414 0 100 16.829 8.414 8.414 0 000-16.829zm10.448 7.196l-.622-.418-.837 1.244.622.419a6.905 6.905 0 11-9.584 9.584l-.419-.623-1.244.838.418.622A8.405 8.405 0 1019.804 8.138z'
      />
    </svg>
  );
}

export default SvgPlaceholder24;
